import { useEffect } from 'react';

// Keeps a form's local brokerGroupId state in step with the selected client's brokerGroupId,
// once the client row has loaded (client selection can resolve brokerGroupId before this does).
export const useSyncBrokerGroupFromClient = (clientRow, setBrokerGroupId) => {
	useEffect(() => {
		if (clientRow?.brokerGroupId) setBrokerGroupId(clientRow.brokerGroupId);
	}, [clientRow?.brokerGroupId, setBrokerGroupId]);
};
